import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';

// ==============================|| GUEST GUARD ||============================== //

const GuestGuard = ({ children }) => {
  const { isLoggedIn, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      navigate(user.defaultPath, { replace: true });
    }
  }, [isLoggedIn, navigate, user]);

  return children || null;
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;
